import { useMemo } from 'react';
import { handleAxiosError } from 'core/notifications';
import { useQuery } from '@tanstack/react-query';
import Axios from 'axios';
import axios from '@/util/axios';
import getAxiosConfig from '../helpers/getAxiosConfig';

export default ({ enrollmentId, isEnabled = false }) => {
  const enrollmentDetailsKey = useMemo(() => ['enrollment', enrollmentId], [enrollmentId]);

  const enrollmentDetails = useQuery(
    enrollmentDetailsKey,
    async ({ signal }) => {
      try {
        return (await axios(getAxiosConfig('get-enrollment-details', { enrollmentId, signal })))
          .data;
      } catch (error) {
        if (Axios.isCancel(error)) return;
        handleAxiosError(error);
      }
    },
    { enabled: isEnabled },
  );

  return {
    enrollmentDetails,
    enrollmentDetailsKey,
  };
};
